import axios from "axios";
import { API_BASE } from "../../src/config/env";
/**APPLICATION START */
export const FETCH_SUGGESTIONS_FULFILLED = "FETCH_SUGGESTIONS_FULFILLED";
export const FETCH_SUGGESTIONS_REJECTED = "FETCH_SUGGESTIONS_REJECTED";
export const FETCH_SUGGESTIONS_PENDING = "FETCH_SUGGESTIONS_PENDING";
export const RESET_SUGGESTIONS = "RESET_SUGGESTIONS"


export function suggestions(message,supportRequestStatus) {

    const token = localStorage.getItem("accessToken")

    return (dispatch) => {
        dispatch({
            type: "FETCH_SUGGESTIONS",
            payload: axios({
                method: "post",
                url: `${API_BASE}/api/v2/notification/contact-us`,
                data: { message, supportRequestStatus},
                headers: {
                    "Authorization": "Bearer " + token,
                    "Accept-Language": "tr-tr",
                    "Client-Id": localStorage.getItem("One-Id"),
                    "One-Id": localStorage.getItem("Client-Id"),
                    "Content-Type": "application/json",
                    "ngrok-skip-browser-warning" : "69920"
                },
            }).then((result) => result.data),
        });
    };
}

export function resetSuggestions() {
    return (dispatch) => {
        dispatch({
            type: "RESET_SUGGESTIONS",
        });
    };
}


